// extracted by mini-css-extract-plugin
export var divider = "_y2-0";